import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SplashScreen() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("fv_splashed"));

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("fv_splashed", "1");
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
          style={{ background: "linear-gradient(150deg, #0D0F17 0%, #161923 60%, #2a1248 120%)" }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          data-testid="splash-screen"
        >
          <motion.img
            src="/fv-logo.png"
            alt="FlippedView"
            className="w-24 h-24 rounded-[22px] shadow-2xl"
            initial={{ scale: 0.6, opacity: 0, rotateY: -90 }}
            animate={{ scale: 1, opacity: 1, rotateY: 0 }}
            transition={{ type: "spring", stiffness: 140, damping: 14 }}
          />
          <motion.h1
            className="font-heading font-extrabold text-3xl mt-6 tracking-tight"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.4 }}
          >
            <span className="text-white">Flipped</span><span className="text-view-b">View</span>
          </motion.h1>
          <motion.p
            className="text-[11px] font-semibold tracking-[0.25em] uppercase text-neutral mt-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.45, duration: 0.4 }}
          >
            Two Sides. One Conversation.
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
